import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'components/common/modal/Modal';

import Privacy from 'components/core/docs/privacy/Privacy';
import Terms from 'components/core/docs/terms/Terms';

import './Footer.css';
import SocialIcons from 'components/common/socialIcons/SocialIcons';
import Logo from 'images/logo.svg';

class Footer extends Component {
  constructor(props){
    super(props);

    this.handleOpenModal = this.handleOpenModal.bind(this);
  }

  handleOpenModal(e) {
    const dataContent = e.target.dataset.content;
    let content, title;

    switch (dataContent) {
      case 'terms':
        title = Terms.title();
        content = <Terms/>;
        break;
      case 'privacy':
        title = Privacy.title();
        content = <Privacy/>;
        break;
      default:
        break;
    }

    if (title && content) {
      this._modal.setState({
        title,
        content
      });
      this._modal.openModal();
    }
  }

  render() {
    return (
      <footer>
        <div className="container">
          <div className="block-left">
            <Link to='/' className="logo"><img src={Logo} alt="IterioData"/></Link>

            <ul className="copyright" onClick={this.handleOpenModal}>
              <li
                data-content="terms"
                data-title="Terms of Service"
              >Terms</li>
              <li
                data-content="privacy"
                data-title="Privacy Policy"
              >Privacy</li>
            </ul>
          </div>
          <SocialIcons/>
        </div>

        <Modal
          ref={(modal) => { this._modal = modal; }}
          className='c-footer__modal'
        />
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/footer/Footer.jsx